import { useState } from 'react';
import axios from 'axios';
import AdminBackButton from '../components/AdminBackButton';

const API_URL = '/backend/api/';  

function AdminCodeGenerator() {
  const [rounds, setRounds] = useState(8);
  const [questions, setQuestions] = useState(8);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [codes, setCodes] = useState([]);

  const generateCode = () => {
    const chars = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
    let code = '';
    for (let i = 0; i < 6; i++) {
      code += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return code;
  };

  const handleGenerate = async () => {
    setLoading(true);
    setMessage('');
    setCodes([]);

    try {
      // Step 1: Create or update the active quiz
      const quizResponse = await axios.post(`${API_URL}create_quiz.php`, {
        rounds: parseInt(rounds),
        questions_per_round: parseInt(questions)
      });

      const quizId = quizResponse.data.quiz_id;

      // Step 2: Generate 50 unique codes
      const newCodes = [];
      while (newCodes.length < 50) {
        const code = generateCode();
        if (!newCodes.includes(code)) newCodes.push(code);
      }

      // Step 3: Save codes to database
      const codesResponse = await axios.post(`${API_URL}generate_codes.php`, {
        quiz_id: quizId,
        codes: newCodes
      });

      setCodes(newCodes);
      setMessage(`Succes! Quiz aangemaakt (ID: ${quizId}) en 50 codes gegenereerd.`);
    } catch (err) {
      setMessage('Fout: ' + (err.response?.data?.message || err.message));
    } finally {
      setLoading(false);
    }
  };

  const copyCodes = () => {
    navigator.clipboard.writeText(codes.join('\n'));
    alert('Codes gekopieerd naar klembord!');
  };

  return (
    <div className="min-h-screen bg-gray-100 px-4 py-8">
      <div className="max-w-2xl mx-auto bg-white rounded-xl shadow-lg p-8">
        <h1 className="text-3xl font-bold mb-8 text-center">Admin: Quiz Instellen & Codes Genereren (AFBLIJVEN TIJDENS QUIZ!)</h1>
        
        <AdminBackButton />

        <div className="grid grid-cols-2 gap-6 mb-8">
          <div>
            <label className="block text-lg font-medium mb-2">Aantal rondes</label>
            <input
              type="number"
              min="1"
              max="20"
              value={rounds}
              onChange={(e) => setRounds(e.target.value)}
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg text-xl"
            />
          </div>
          <div>
            <label className="block text-lg font-medium mb-2">Vragen per ronde</label>
            <input
              type="number"
              min="1"
              max="20"
              value={questions}
              onChange={(e) => setQuestions(e.target.value)}
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg text-xl"
            />
          </div>
        </div>

        <button
          onClick={handleGenerate}
          disabled={loading}
          className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 rounded-lg text-xl mb-6 disabled:opacity-50"
        >
          {loading ? 'Bezig met genereren...' : 'Genereer 50 codes & maak quiz aan'}
        </button>

        {message && (
          <p className={`text-center text-lg mb-6 p-4 rounded-lg ${message.includes('Succes') ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
            {message}
          </p>
        )}

        {codes.length > 0 && (
          <div>
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold">Gegenereerde codes:</h2>
              <button
                onClick={copyCodes}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg"
              >
                Kopiëren
              </button>
            </div>
            <div className="grid grid-cols-3 sm:grid-cols-5 gap-3 text-center">
              {codes.map((code, i) => (
                <div key={i} className="bg-gray-200 py-3 rounded font-mono text-lg font-bold">
                  {code}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminCodeGenerator;